var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 17.3C11.3 17.3 10.6 17.03 10.07 16.5L3.55002 9.98C3.26002 9.69 3.26002 9.21 3.55002 8.92C3.84002 8.63 4.32002 8.63 4.61002 8.92L11.13 15.44C11.61 15.92 12.39 15.92 12.87 15.44L19.39 8.92C19.68 8.63 20.16 8.63 20.45 8.92C20.74 9.21 20.74 9.69 20.45 9.98L13.93 16.5C13.4 17.03 12.7 17.3 12 17.3Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down-arrow.3c6b30fc6fd3f2b6f0259d9e5df8614f.svg";
export { ForwardRef as ReactComponent };